"use client";

import { cn } from "@jesus-central-church/shared";
import { EventCardWide } from "./event-card-wide";
import type { EventUI } from "./types";

export interface EventsTimelineProperties {
  groups: { monthKey: string; label: string; events: EventUI[] }[];
  className?: string;
}

export function EventsTimeline({
  groups,
  className,
}: EventsTimelineProperties) {
  return (
    <div className={cn("space-y-12", className)}>
      {groups.map((group) => (
        <div key={group.monthKey} id={`month-${group.monthKey}`}>
          {/* Month Header */}
          <div className="mb-6 flex items-center gap-4">
            <h2 className="font-extrabold text-3xl tracking-tight text-freedom uppercase md:text-4xl">
              {group.label}
            </h2>
            <span className="bg-strategy-gold rounded-full px-3 py-1 text-sm font-bold text-freedom">
              {group.events.length}
            </span>
            <div className="h-px flex-1 bg-freedom/10" />
          </div>

          {/* Events */}
          <div className="space-y-4">
            {group.events.map((event) => (
              <EventCardWide
                key={event.id}
                event={event}
                variant={event.featured ? "featured" : "default"}
              />
            ))}
          </div>
        </div>
      ))}
    </div>
  );
}
